import React from 'react';
import MainPanel from '../../components/layout/MainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';
import DashboardBody from '../Dashboard';

export default function ReportsOverview() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const profile = data?.profile;
  return (
    <MainPanel
      variant="reports"
      title={t('reports.overviewTitle')}
      subtitle={
        profile?.displayName
          ? t('reports.overviewSubtitleNamed', { name: profile.displayName })
          : t('reports.overviewSubtitle')
      }
    >
      <DashboardBody />
    </MainPanel>
  );
}
